import axios from 'axios'
import $store from '@/store'
import { setError } from './errorParser'

const _axios = axios.create({
  baseURL: `${process.env.common.defaultV2Api.host}`,
})

_axios.interceptors.request.use(
  async (config) => {
    await $store.dispatch('auth/sync')
    if (config.isInterceptor !== false) {
      if (
        config.headers.Authorization == null ||
        config.headers.Authorization.startsWith('Basic') === false
      ) {
        const token = $store.state.auth.token
        if (token != null) {
          config.headers.Authorization = `Bearer ${token}`
        }
      }
    }

    return config
  },
  (error) => {
    // Do something with request error
    return Promise.reject(error)
  },
)

_axios.interceptors.response.use(
  (resp) => {
    return Promise.resolve(resp)
  },
  async (error) => {
    try {
      const errorResponse = setError(error.response)
      return Promise.reject(errorResponse)
    } catch (e) {
      return Promise.reject(error)
    }
  },
)

// _axios.call = async option => {
//   // await $store.dispatch('auth/sync')
//   return _axios(Vue.util.extend({}, option))
// }

export default _axios
